export function capitalizeFirstLetter(str) {
  return str.slice(0, 1).toUpperCase() + str.slice(1, str.length);
}

export function convertToMillions(num) {
  const str = num.toString().split("").reverse().join("");
  const parts = str.match(/.{1,3}/g);
  const result = parts.join(",").split("").reverse().join("");
  return result;
}

export function validateLetters(key) {
  const validRegex = /^[a-zA-Z\s]$/;
  return validRegex.test(key) || key === "Backspace";
}

export function validateContact(key) {
  const validRegex = /^[0-9+]+$/;
  return validRegex.test(key) || key === "Backspace";
}

export function validateEmail(email) {
  const validRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return validRegex.test(email);
}

export function validatePassword(password) {
  return password.length >= 8;
}
export function TruncateString(string, length) {
  if (string?.length <= length) {
    return string;
  } else {
    return string?.slice(0, length) + "..";
  }
}
export const getOrdinalSuffix = (rank) => {
  const suffixes = ["th", "st", "nd", "rd"];
  const v = rank % 100;
  return rank + (suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0]);
};

// USD Formatter

export function formatCurrency(amount) {
  const num = Number(amount);
  if (isNaN(num)) {
    return "$0.00";
  }
  return num.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
  });
}

// USD formatter with no decimal
export function formatCurrencyWithoutDecimal(amount) {
  const num = Number(amount) || 0;
  return num.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
}

export function generateRandomId(length = 20) {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const timestamp = Date.now().toString(); // Get the numeric value from Date.now()
  const alphanumericLength = length - timestamp.length; // Calculate space for alphanumeric part

  // Generate the alphanumeric part
  let alphanumericPart = Array.from(
    { length: alphanumericLength },
    () => characters[Math.floor(Math.random() * characters.length)]
  ).join("");

  // Combine the alphanumeric part with the timestamp
  let combinedId = alphanumericPart + timestamp;

  // Shuffle the combined string to mix alphanumeric and numeric parts
  let shuffledId = combinedId
    .split("")
    .sort(() => Math.random() - 0.5)
    .join("");

  return shuffledId;
}
